module.exports = __webpack_public_path__ + "static/media/568.576e05b2.png";